/* tslint:disable */

declare var Object: any;
export interface IntegrationInterface {
  "id"?: number;
}

export class Integration implements IntegrationInterface {
  "id": number;
  constructor(data?: IntegrationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Integration`.
   */
  public static getModelName() {
    return "Integration";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Integration for dynamic purposes.
  **/
  public static factory(data: IntegrationInterface): Integration{
    return new Integration(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Integration',
      plural: 'Integrations',
      path: 'Integrations',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
